/* PUFATI · Aureole: small, dependency-free progressive enhancements. */
(function () {
  'use strict';
  document.documentElement.classList.add('has-js');

  function setupLanguage(scope) {
    (scope || document).querySelectorAll('[data-locale-picker]').forEach(function (picker) {
      if (picker.dataset.ready) return;
      picker.dataset.ready = '1';
      picker.addEventListener('change', function () {
        var form = picker.closest('form');
        if (form) form.submit();
      });
    });
  }

  function conditional(select, group, child, match) {
    if (!select || !group || !child) return function () {};
    function update() {
      var yes = select.value === match;
      group.hidden = !yes;
      child.disabled = !yes;
      child.required = yes;
      if (!yes) child.value = '';
    }
    if (!select.dataset['conditional' + match.replace(/\W/g, '')]) {
      select.addEventListener('change', update);
      select.dataset['conditional' + match.replace(/\W/g, '')] = '1';
    }
    update();
    return update;
  }

  function setupSupplier(scope) {
    (scope || document).querySelectorAll('.supplier-section').forEach(function (section) {
      if (section.dataset.formReady) return;
      section.dataset.formReady = '1';
      var material = section.querySelector('[data-supplier-material]');
      var otherMaterialGroup = section.querySelector('[data-other-material-field]');
      var otherMaterialInput = otherMaterialGroup && otherMaterialGroup.querySelector('input');
      conditional(material, otherMaterialGroup, otherMaterialInput, 'Other');

      var county = section.querySelector('[data-supplier-county]');
      var countryGroup = section.querySelector('[data-supplier-country-field]');
      var country = section.querySelector('[data-supplier-country]');
      var otherCountryGroup = section.querySelector('[data-supplier-other-country-field]');
      var otherCountryInput = otherCountryGroup && otherCountryGroup.querySelector('input');
      var updateCountry = conditional(county, countryGroup, country, 'Outside Romania');
      var updateOtherCountry = conditional(country, otherCountryGroup, otherCountryInput, 'Other country');
      if (county) county.addEventListener('change', function () { updateCountry(); updateOtherCountry(); });
    });
  }

  function setupGallery(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var mainImg = root.querySelector('[data-gallery-main] img');
      root.querySelectorAll('[data-gallery-src]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.src = thumb.dataset.gallerySrc;
          mainImg.alt = thumb.dataset.galleryAlt || '';
          mainImg.removeAttribute('srcset');
          root.querySelectorAll('[data-gallery-src]').forEach(function (b) { b.classList.remove('is-current'); });
          thumb.classList.add('is-current');
        });
      });
      var qty = root.querySelector('[data-qty-input]');
      var variant = root.querySelector('[data-variant-select]');
      var fixedPrice = root.querySelector('[data-variant-price]');
      var unit = root.querySelector('[data-variant-unit-price]');
      var compare = root.querySelector('[data-variant-compare-price]');
      var total = root.querySelector('[data-product-total]');
      var addButton = root.querySelector('button[name="add"]');
      if (!qty || !total) return;
      var code = root.dataset.currency || 'EUR';
      var locale = root.dataset.locale === 'ro' ? 'ro-RO' : 'en-GB';
      var money;
      try { money = new Intl.NumberFormat(locale, {style:'currency', currency:code}); }
      catch (error) { money = new Intl.NumberFormat('en-GB', {style:'currency', currency:'EUR'}); }
      function getPrice() {
        if (variant && variant.selectedOptions[0]) return Number(variant.selectedOptions[0].dataset.price) || 0;
        return fixedPrice ? Number(fixedPrice.dataset.variantPrice) || 0 : 0;
      }
      function getComparePrice() {
        if (variant && variant.selectedOptions[0]) return Number(variant.selectedOptions[0].dataset.compareAtPrice) || 0;
        return fixedPrice ? Number(fixedPrice.dataset.variantCompareAtPrice) || 0 : 0;
      }
      function update() {
        var n = Math.max(1, Math.floor(Number(qty.value) || 1));
        var cents = getPrice();
        if (unit) unit.textContent = money.format(cents / 100);
        if (compare) {
          var compareCents = getComparePrice();
          compare.hidden = !(compareCents > cents);
          if (compareCents > cents) compare.textContent = money.format(compareCents / 100);
        }
        total.textContent = money.format((cents * n) / 100);
        if (variant && addButton && variant.selectedOptions[0]) {
          addButton.disabled = variant.selectedOptions[0].dataset.available !== 'true';
        }
      }
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, Math.floor(Number(qty.value) || 1) - 1); update(); });
      if (plus) plus.addEventListener('click', function () { qty.value = Math.max(1, Math.floor(Number(qty.value) || 1) + 1); update(); });
      qty.addEventListener('input', update);
      qty.addEventListener('change', function () { qty.value = Math.max(1, Math.floor(Number(qty.value) || 1)); update(); });
      if (variant) variant.addEventListener('change', function () {
        update();
        try { var url = new URL(window.location.href); url.searchParams.set('variant', variant.value); window.history.replaceState({}, '', url.toString()); } catch (e) {}
      });
      update();
    });
  }

  function setupMobile(scope) {
    (scope || document).querySelectorAll('[data-mobile-drawer]').forEach(function (drawer) {
      if (drawer.dataset.ready) return;
      drawer.dataset.ready = '1';
      drawer.addEventListener('keydown', function (event) { if (event.key === 'Escape') drawer.open = false; });
      var closeButton = drawer.querySelector('[data-mobile-close]');
      if (closeButton) closeButton.addEventListener('click', function () { drawer.open = false; });
      drawer.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', function () { drawer.open = false; }); });
    });
  }

  function setupReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('is-visible'); }); return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: .07, rootMargin: '0px 0px 60px 0px' });
    items.forEach(function (item) { if (item.dataset.revealReady) return; item.dataset.revealReady = '1'; observer.observe(item); });
  }

  function init(scope) {
    setupLanguage(scope); setupSupplier(scope); setupGallery(scope); setupMobile(scope); setupReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {init(document);});
  else init(document);
  document.addEventListener('shopify:section:load', function (event) {init(event.target);});
})();
